import { render, staticRenderFns } from "./TransferEnd.vue?vue&type=template&id=070cb192&scoped=true&"
import script from "./TransferEnd.vue?vue&type=script&lang=js&"
export * from "./TransferEnd.vue?vue&type=script&lang=js&"
import style0 from "./TransferEnd.vue?vue&type=style&index=0&id=070cb192&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070cb192",
  null
  
)

export default component.exports